/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import { Module, Node, SingleSlideCarousel, ISingleSlideCarouselProps, IComponentNodeProps } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IImageListViewProps } from '@msdyn365-commerce-modules/image-list/src/modules/image-list/./image-list';
import { IImageListProps } from '../definition-extensions/image-list.ext.props.autogenerated';

/**
 * Render the thumbnail item images.
 * @param props - The image list view props.
 * @returns Return HTML having IImageListViewProps props with image List.
 */
export const imageListView = (props: IImageListViewProps & IImageListProps<{}>): JSX.Element => {
    const propsCarousel: IComponentNodeProps<ISingleSlideCarouselProps> = {
        tag: SingleSlideCarousel,
        className: 'custom-carousel',
        flipperPrevLabel: 'Previous',
        flipperNextLabel: 'Next',
        parentId: props.id,
        vertical: false
    };

    const { imageList, imageListContainer, imageListHeading, imageListItem, imageListItemAnchorTag, config } = props;
    const classname = config.direction === 'vertical' ? 'moe-image-list-container img-list-vertical' : 'moe-image-list-container';
    const imagesList = props.config.images;

    /**
     * Handle paragraph change.
     * @param index - Index of image item in array of image items.
     * @returns Void.
     */
    const handleParagraphChange = (index: number) => (event: Msdyn365.ContentEditableEvent): void => {
        if (props.config.images![index]) {
            props.config.images![index].paragraph = event.target.value;
        }
    };

    const showLightbox = (imageSrc: any, link: any) => {
        if (link?.linkUrl?.destinationUrl) {
            return;
        }
        var lightbox: any;
        var lightboxImage: any;

        lightbox = document.createElement('div');
        lightbox.id = 'moe-lightbox';
        document.body.appendChild(lightbox);
        lightboxImage = document.createElement('img');
        lightbox.appendChild(lightboxImage);
        lightboxImage.src = 'https://images-au-prod.cms.commerce.dynamics.com/cms/api/qsjhkgqqvf/imageFileData/MLkQr?ver=0c7a';

        lightbox.addEventListener('click', (e: any) => {
            if (e.target !== e.currentTarget) return;
            lightbox.classList.remove('active');
            document.body?.removeChild(lightbox);
        });

        window.addEventListener('keyup', ({ key, keyCode }) => {
            if (key !== 'Escape' || keyCode != 27) return;
            lightbox.classList.remove('active');
            document.body?.removeChild(lightbox);
        });

        console.log(imageSrc);
        console.log(lightbox);
        lightbox.setAttribute('class', 'active');
        lightboxImage.src = imageSrc;
    };

    return (
        <div className={classname}>
            <Module {...imageList}>
                {imageListHeading}
                <Node {...imageListContainer}>
                    <Node {...propsCarousel}>
                        {imagesList?.map((item, index) => {
                            const { image, link, paragraph } = item;

                            // let indexKey: string;

                            // if (item.image) {
                            //     const image = (item.image as unknown) as Msdyn365.Image;
                            //     indexKey = image.props.src as string;
                            // } else {
                            //     const text = (item.text as unknown) as Msdyn365.RichTextComponent;
                            //     indexKey = text.props.text as string;
                            // }
                            return (
                                <Node {...imageListItem} key={index}>
                                    {item.image && (
                                        <Node
                                            {...imageListItemAnchorTag}
                                            altText={link?.linkText ?? link?.ariaLabel}
                                            href={link?.linkUrl.destinationUrl}
                                            target={link?.openInNewTab ? '_blank' : ''}
                                            aria-label={link?.ariaLabel}
                                            className={imageListItemAnchorTag.className}
                                        >
                                            <img
                                                title={item.image.title}
                                                onClick={() => showLightbox(image?.src, link)}
                                                src={image?.src ? image.src : ''}
                                                alt={item.image.altText}
                                            />
                                        </Node>
                                    )}
                                    {paragraph && (
                                        <Msdyn365.RichTextComponent
                                            text={paragraph as Msdyn365.RichText | undefined}
                                            className='ms-image-list__text'
                                            editProps={{
                                                onEdit: handleParagraphChange(index),
                                                requestContext: props.context.request
                                            }}
                                        />
                                    )}
                                </Node>
                            );
                        })}
                    </Node>
                </Node>
            </Module>
        </div>
    );
};

export default imageListView;
